export default {
	install(Vue, { sectionName = '카페탑', pageName = '인기글뷰' } = {}) {
		const prefix = `${sectionName}>${pageName}`;

		const isDefined = () => typeof TiaraTracker !== 'undefined';

		const generateProps = (custom = {}) => {
			return {...custom}
		};

		Vue.prototype.$trackEvent = ({ layer, desc, url = '', customProps = {}, eventMeta = {} }) => {
			if (!isDefined()) return;
			TiaraTracker.getInstance()
				.trackEvent(`${prefix}>${desc}`)
				.click({
					layer1: layer,
					layer2: '',
					layer3: '',
					click_url: url.slice(0, 255),
					copy: '',
					posx: 0,
					posy: 0
				})
				.actionKind('ClickContent')
				.customProps(generateProps(customProps))
				.eventMeta(eventMeta)
				.track();
		};

		Vue.prototype.$trackViewImp = ({ page, pageName: vPageName, layerName, contents, customProps = {} }) => {
			if (!isDefined() || !contents.length) return;
			TiaraTracker.getInstance()
				.setSection('user_action')
				.setPage(page)
				.trackViewImp(`유저액션_${vPageName}_${layerName}`)
				.actionKind('ViewContent')
				.viewImpContents(contents)
				.customProps(generateProps(customProps))
				.track();
		};
	}
}
